import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useSettingsStore } from '@/store/settings'

interface Props {
  active: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleSwitch',
  props: {
    active: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  active: boolean
}


const settingsStore = useSettingsStore()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["toggle-slot relative w-[33px] h-[20px] border border-stone rounded-[20px]", {
        'bg-stone-95': !props.active,
        'bg-stone-85': props.active && !_unref(settingsStore).highContrast,
        'bg-poppy': props.active && _unref(settingsStore).highContrast,
        'border-stone': !props.active || !_unref(settingsStore).highContrast,
        'border-poppy': props.active && _unref(settingsStore).highContrast,
      }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["toggle-switch relative w-[18px] h-[18px] rounded-[18px]", {
          'bg-slateGray': !props.active || _unref(settingsStore).highContrast,
          'bg-stone-95': props.active && !_unref(settingsStore).highContrast,
          'left-0': !props.active,
          'left-[13px]': props.active,
        }])
      }, null, 2)
    ], 2)
  ]))
}
}

})